import { render, staticRenderFns } from "./SurgeryReviewList.vue?vue&type=template&id=cdde859e&scoped=true"
import script from "./SurgeryReviewList.vue?vue&type=script&lang=js"
export * from "./SurgeryReviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdde859e",
  null
  
)

export default component.exports